import React, { Component, useEffect, useState } from "react";
import { Input, Label, FormGroup } from "reactstrap";

import axios from "axios";
import { API_URL } from "../../constants";


function EMRInfo(props) { 
    
    const [EMR_types, setEMR_types] = useState([])

    const statuses = ["", 'Active', 'Stalled/Inactive', 'Discontinued'];
 
    const getEmrTypes = async() => {
        await axios.get(API_URL+"/emr_types").then(res => setEMR_types( res.data ));
       };

    useEffect(() => {        
        getEmrTypes()  
              
    }, [])

        return (
            
            <div id="EMR_info">
                 <h6  className="green_text_color">CT Information</h6>
                <div id="EMR" className="row  mb-5 form_section shadow-sm bg-white rounded p-4" >

                    <b>EMR modules</b>
                    <div className="d-flex justify-content-between">
                        <FormGroup check>
                            <Input id="ovc_offered" name="ovc_offered" type="checkbox" checked={props.facility_data.ovc_offered}
                            className={ props.Original_data && props.Original_data.ovc_offered != props.facility_data.ovc_offered && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "ovc_offered":e.target.checked})}/>                   
                            <Label check>OVC</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="otz_offered" name="otz_offered" type="checkbox" checked={props.facility_data.otz_offered}
                            className={ props.Original_data && props.Original_data.otz_offered != props.facility_data.otz_offered && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "otz_offered":e.target.checked})}/>                   
                            <Label check>OTZ</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="prep_offered" name="prep_offered" type="checkbox" checked={props.facility_data.prep_offered}
                            className={ props.Original_data && props.Original_data.prep_offered != props.facility_data.prep_offered && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "prep_offered":e.target.checked})}/>                   
                            <Label check>PrEP</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="tb_offered" name="tb_offered" type="checkbox"checked={props.facility_data.tb_offered} 
                            className={ props.Original_data && props.Original_data.tb_offered != props.facility_data.tb_offered && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "tb_offered":e.target.checked})}/>                   
                            <Label check>TB</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="mnch_offered" name="mnch_offered" type="checkbox" checked={props.facility_data.mnch_offered}
                            className={ props.Original_data && props.Original_data.mnch_offered != props.facility_data.mnch_offered && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "mnch_offered":e.target.checked})}/>                   
                            <Label check>MNCH</Label>
                        </FormGroup>

                        <FormGroup check>
                            <Input id="tpt_offered" name="tpt_offered" type="checkbox" checked={props.facility_data.tpt_offered}
                            className={ props.Original_data && props.Original_data.tpt_offered != props.facility_data.tpt_offered && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "tpt_offered":e.target.checked})}/>                   
                            <Label check>TPT</Label>
                        </FormGroup>  
                        <FormGroup check>
                            <Input id="covid_19_offered" name="covid_19_offered" type="checkbox" checked={props.facility_data.covid_19_offered}
                            className={ props.Original_data && props.Original_data.covid_19_offered != props.facility_data.covid_19_offered && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "covid_19_offered":e.target.checked})}/>                   
                            <Label check>Covid-19</Label>
                        </FormGroup>  
                        <FormGroup check>
                            <Input id="evmmc_offered" name="evmmc_offered" type="checkbox" checked={props.facility_data.evmmc_offered}
                            className={ props.Original_data && props.Original_data.evmmc_offered != props.facility_data.evmmc_offered && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "evmmc_offered":e.target.checked})}/>                   
                            <Label check>EVMMC</Label>
                        </FormGroup>  


                    </div>                   
                </div>
            </div>
        );
    //  }
}

export default EMRInfo;
